import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import {
  PaymentApi,
  RequestStrategyEnum,
  type GetDepositPaymentsByAccountsRequest,
  type GetDepositPaymentsResponse,
  type WithSignal,
} from '@shared/api';

const getPaymentsByAccountsEffect = createEffect(({ signal, ...request }: WithSignal<GetDepositPaymentsByAccountsRequest>) =>
  PaymentApi.getPaymentsByAccounts(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ data: GetDepositPaymentsResponse[]; total: number }>({ data: [], total: 0 })
  .on(getPaymentsByAccountsEffect.done, (_, data) =>
    data.result ? { data: data.result.data || [], total: data.result.total } : { data: [], total: 0 },
  )
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getPaymentsByAccountsEffect.pending, (_, data) => data)
  .on(getPaymentsByAccountsEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getPaymentsByAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getPaymentsByAccountsEffect, () => null)
  // .on(getPaymentsByAccountsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getPaymentsByAccountsEffect.fail, () => 'Something went wrong while fetching Transactions. Please try again.')
  .on(getPaymentsByAccountsEffect.done, () => null)
  .reset(clearEvent);

const getPaymentsByAccountsApi = ApiUtilsV2.wrapperApi(getPaymentsByAccountsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getPaymentsByAccountsApi.cancel());

export const $paymentStore = {
  events: {
    getPaymentsByAccounts: getPaymentsByAccountsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
